export default {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      border: "1px solid ".concat(v.foregroundColor)
    };
  }
};